import React from "react";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import CountUp from "react-countup";
import { useTaxSelector } from "../../../redux/general/reduxStore";
import Stack from "@mui/material/Stack";
import useIAmAccountant from "../../accountant/function/useIAmAccountant";
import { navigationLinks } from "../../../navigation/Navigation";
import { NavLink } from "react-router-dom";

const CreditComponent = ({ small }: { small?: boolean }) => {
    const { t } = useTranslation();
    const { credit } = useTaxSelector((state) => state.user);
    const { accountant, isAccountant } = useIAmAccountant();

    return isAccountant ? (
        <CountUp decimals={2} delay={0} start={credit?.oldCredit ?? 0} end={credit?.credit ?? 0} duration={1} separator=" " decimal=",">
            {({ countUpRef }) => (
                <Stack direction="row" spacing={1} alignItems="center">
                    <NavLink style={{ textDecoration: "none" }} to={`${navigationLinks.TAX_LICENCES_LINK}/${accountant?.licence?.id}`}>
                        <Typography variant={small ? "body2" : "body1"} color="primary.main" ref={countUpRef} />
                    </NavLink>
                    <Typography variant="body2" color="secondary.main">
                        {t("licence.credit", { count: credit?.credit })}
                    </Typography>
                </Stack>
            )}
        </CountUp>
    ) : null;
};

export default CreditComponent;
